import { EnergyLabelColor, EnergyLabelVersion } from "src/models/common/energy.enums";
import { EnergyLabelRange, EnergyLabelSingle } from "src/models/common/energylabel.model";

export class EnergyLabelUtil {
    static createColorClass(label: string, color: string): string {
        let colorClass = "";
        switch (color) {
            case "Grønn":
                colorClass = label + "-green";
                break;
            case "Lys grønn":
                colorClass = label + "-lightgreen";
                break;
            case "Gul":
                colorClass = label + "-yellow";
                break;
            case "Oransje":
                colorClass = label + "-orange";
                break;
            case "Rød":
                colorClass = label + "-red";
                break;
            default:
                colorClass = "";
        }
        return colorClass.toLowerCase();
    }

    static createEnergyLabelWithCssString(energyLabeling: EnergyLabelSingle): EnergyLabelSingle {
        if (energyLabeling == null) {
            return null;
        }
        if (energyLabeling.energyLabelVersion !== EnergyLabelVersion.Version2026) {
            energyLabeling.energyLabelCss = this.createOldEnergyLabelClass(
                energyLabeling.energyLabel,
                energyLabeling.energyLabelingColor,
                energyLabeling.isExpired,
            );
        }
        if (energyLabeling.energyLabelVersion === EnergyLabelVersion.Version2026) {
            energyLabeling.energyLabelCss = this.create2026EnergyLabelClass(energyLabeling);
        }
        return energyLabeling;
    }
    static createEnergyLabelRangeWithCssStrings(energyLabelingRange: EnergyLabelRange): EnergyLabelRange {
        if (energyLabelingRange == null) {
            return null;
        }

        energyLabelingRange.energyLabelingBest = this.createEnergyLabelWithCssString(energyLabelingRange.energyLabelingBest);
        energyLabelingRange.energyLabelingWorst = this.createEnergyLabelWithCssString(energyLabelingRange.energyLabelingWorst);
        energyLabelingRange.energyLabelingMedian = this.createEnergyLabelWithCssString(energyLabelingRange.energyLabelingMedian);

        return energyLabelingRange;
    }
    private static create2026EnergyLabelClass(energyLabeling: EnergyLabelSingle): string {
        if (energyLabeling == null) {
            return null;
        }
        let css = "icon-energy26-" + energyLabeling.energyLabel.toLowerCase();
        return css;
    }
    private static createOldEnergyLabelClass(label: string, color: EnergyLabelColor, isExpired: boolean): string {
        let colorClass = "";
        switch (color) {
            case EnergyLabelColor.Unknown:
                colorClass = label + "-unknowncolor";
                break;
            case EnergyLabelColor.Green:
                colorClass = label + "-green";
                break;
            case EnergyLabelColor.LightGreen:
                colorClass = label + "-lightgreen";
                break;
            case EnergyLabelColor.Yellow:
                colorClass = label + "-yellow";
                break;
            case EnergyLabelColor.Orange:
                colorClass = label + "-orange";
                break;
            case EnergyLabelColor.Red:
                colorClass = label + "-red";
                break;
            default:
                colorClass = "";
        }
        return colorClass.toLowerCase();
    }
}
